module.exports = __webpack_public_path__ + "static/img/农业.7ac323b3.png";